import {
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  Typography,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import logo from '../../assets/images/logo-small.png';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { VideoModal } from '../Common/VideoModal';

export const CrearCuenta = () => {
  return (
    <Container component='main' maxWidth='sm' style={{ padding: '0' }}>
      <ButtonBack />

      <Card>
        <CardContent sx={{ my: { xs: 2, md: 4 }, mx: { xs: 2, md: 5 } }}>
          <Grid
            container
            direction='column'
            justifyContent='center'
            alignItems='center'
            gap={2}
          >
            <Avatar alt='OSER' src={logo} sx={{ width: 70, height: 70 }} />

            <Typography gutterBottom variant='h5' component='h2'>
              Crear Cuenta mi.Consultorio
            </Typography>
            <VideoModal
              sx={{ pt: 1 }}
              src={'https://www.youtube.com/embed/-2QE2im_GJQ?si=PaHS4j3s4UCbnACP&autoplay=1'}
            />

            <Typography variant='body1' component='h2' gutterBottom>
              Si aún no tienes una cuenta, sigue estos pasos para solicitar tu usuario y acceder a
              la aplicación mi.Consultorio
            </Typography>

            <Typography variant='body1' paragraph marginBottom={'1px'}>
              <strong>1 - Completa el formulario de actualización de datos</strong>, debes firmarlo
              y sellarlo.
              <Button
                size='small'
                endIcon={<LinkIcon />}
                href='https://www.oser.gob.ar/images/iosper_archivos/Formularios/formAltaProfesionales.pdf'
                target='_blank'
                color='info'
                sx={{ fontSize: '0.775rem', fontWeight: '500', ml: 1 }}
              >
                Ver formulario
              </Button>
            </Typography>

            <Typography variant='body1' paragraph>
              <strong>2 - Entrega el formulario</strong> en cualquiera de las oficinas de OSER de la
              provincia. La Dirección de Despacho de OSER se encargará de procesarlo.
            </Typography>

            <Typography variant='body1' paragraph>
              <strong>3 - Espera la confirmación</strong>, una vez procesada tu solicitud, te
              enviaremos por correo electrónico tu usuario y contraseña (firma electrónica) a la
              dirección de email que registraste.
            </Typography>

            <Alert severity='info' sx={{ mt: 2 }}>
              <AlertTitle>Si necesitas ayuda o tienes alguna pregunta</AlertTitle>
              <Typography variant='body2' color='textSecondary' component='p' gutterBottom>
                No dudes en contactar a la Dirección de Despacho o a Soporte de Sistemas a través de
                estos correos
              </Typography>
              <ul>
                <li>
                  <Link
                    href='mailto:registro.prestadores@oser.gob.ar'
                    underline='hover'
                    color={'secondary'}
                  >
                    registro.prestadores@oser.gob.ar
                  </Link>
                </li>
              </ul>
            </Alert>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
};
